<template>
    <div id="tryoutgroup-chooser">
        <div class="input-group">
            <!-- <button type="button" class="btn btn-inverse" @click="openGroupModal" v-if="$route.name !== 'DetailPaketMapel'">Pilih ...</button> -->
        </div>
        <transition name="modal" v-if="showModal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div id="modal" class="modal-container">
                    <div class="modal-header">Pilih Mata Pelajaran</div>
                    <div class="modal-body" style="overflow: auto !important;">
                        <app-datatable :items="rows" :headers="headers" :hasAction="false" v-on:dblClicked="onMapelChoosen($event)"></app-datatable>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" @click="showModal = false">Close</button>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>
<style scoped>
.modal-container {
  width: 50%;

}
</style>
<script>
import Spinner from '@/components/plugins/Spinner'
import DataTable from '@/components/plugins/DataTable'
import TryoutService from '@/services/tryout.js'
import BimbelService from '@/services/bimbel.js'

export default {
    name: 'tryoutgroup-chooser',
    props: ['params'],
    components: {
        'app-spinner': Spinner,
        'app-datatable': DataTable,
    },
    data: function () {
        return {
            isLoading: false,
            showModal: false,
            headers: ['Mata Pelajaran', 'Nama', 'Kelas'],
            rows: []
        }
    },
    methods: {
        openGroupModal: function () {
            this.isLoading = true
            this.showModal = true

            var context = this
            BimbelService.getListPackage( (response) => {
                if (response.success) {
                    context.rows = []
                    response.data.forEach(function (data) {
                        var row = {
                            id: data.id,
                            data: [data.mapel_name, data.name, data.grade]
                        }

                        context.rows.push(row)
                    })
                }

                context.isLoading = false
            }, this.grade, null).catch(function (error) {
                context.isLoading = false
            })
        },
        onMapelChoosen: function (item) {
            this.showModal = false
            this.$emit('dblClicked', item)
        }
    }
}
</script>


// WEBPACK FOOTER //
// MapelChooser.vue?61a19244